"use client";
import useTranslate from "@app/_hooks/useTranslate";
import type { ResultCode } from "@adyen/adyen-web";

import { useCheckoutContext } from "../../Checkout.hooks";
import CheckoutMessage from "../../CheckoutMessage";

export default function AdyenErrorMessage({
  resultCode,
  message,
}: {
  resultCode?: ResultCode;
  message?: string;
}) {
  const t = useTranslate();
  useCheckoutContext();

  if (resultCode === "Refused") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {t("adyenPaymentRefusedTitle") ?? "Payment failed"}
        </h3>
        {t("adyenPaymentRefusedText") ??
          "Your payment was refused. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (resultCode === "Cancelled") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {t("adyenPaymentCancelledTitle") ?? "Payment cancelled"}
        </h3>
        {t("adyenPaymentCancelledText") ??
          "Your payment was cancelled. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (resultCode === "Error") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {t("adyenPaymentErrorTitle") ?? "Payment error"}
        </h3>
        {t("adyenPaymentErrorText") ??
          "An error occurred while processing your payment. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (message?.includes("Not Found")) {
    return (
      <CheckoutMessage type="error">
        {t("adyenNotFoundError")}
      </CheckoutMessage>
    );
  }

  return (
    <CheckoutMessage type="error">
      {message ?? t("adyenUnknownError")}
    </CheckoutMessage>
  );
}
